import '../../../stylesheets/3d.scss'
import {RENDER_FORMATS, STATUS_TYPES, MESSAGE_RESPONSE_TYPES} from '../../render/constants'
import {logger} from '../../render/setup-globals'
import Status from '../../render/status'
import {defaultViewerConfig} from '../lib/config'
import ThreeDViewer from '../lib/viewer'

export async function markdownInitializer() {
  const configs = defaultViewerConfig()
  const contentNode = document.getElementById('solid-viewer')

  if (!contentNode) {
    logger.debug('No #solid-viewer node found')
    return
  }

  const loader = new Status(RENDER_FORMATS.solid)

  document.addEventListener(MESSAGE_RESPONSE_TYPES.markdown, (event: MarkdownResponseEvent) => {
    const {detail} = event
    try {
      new ThreeDViewer('#solid-viewer', function (error: string | null, viewer: ThreeDViewer) {
        if (error) {
          viewer.status.set(STATUS_TYPES.error, {error})
          return
        }

        viewer.loadMarkdown(detail.data, configs)
      })
    } catch (e) {
      loader.set(STATUS_TYPES.error, {error: (e as Error).message})
    }
  })

  loader.set(STATUS_TYPES.markdown)
}
